import {
  type ActiveTx,
  LISTED_TX_TYPES,
  type ReceivedSnapshot,
  type SseBucket,
} from '@apm/contracts';

/**
 * 스냅샷 버킷을 화면용 한 표로 편다 (CLAUDE.md 실시간 경로).
 *
 * `sse`는 여기 섞지 않는다. 수십 분짜리 연결이 항상 위를 차지해 http를 밀어낸다.
 * 건수와 최장 연결만 따로 낸다.
 */

export interface ActiveRow extends ActiveTx {
  service: string;
  instance: string;
}

export function flattenActive(snapshots: readonly ReceivedSnapshot[]): ActiveRow[] {
  const rows: ActiveRow[] = [];
  for (const snapshot of snapshots) {
    for (const type of LISTED_TX_TYPES) {
      for (const tx of snapshot.activeTx[type]) {
        rows.push({ ...tx, service: snapshot.service, instance: snapshot.instance });
      }
    }
  }
  return rows.sort((a, b) => b.elapsedMs - a.elapsedMs);
}

/** 인스턴스가 여럿이면 건수는 더하고 최장 연결은 가장 긴 것을 쓴다 */
export function mergeSse(snapshots: readonly ReceivedSnapshot[]): SseBucket {
  let count = 0;
  let maxElapsedMs = 0;
  for (const snapshot of snapshots) {
    count += snapshot.activeTx.sse.count;
    maxElapsedMs = Math.max(maxElapsedMs, snapshot.activeTx.sse.maxElapsedMs);
  }
  return { count, maxElapsedMs };
}
